<div [class]="collapseClasses">
  <input type="checkbox" [checked]="isOpen" (change)="toggle()" />
  <div class="collapse-title">
    <ng-content select="[collapse-title]"></ng-content>
  </div>
  <div class="collapse-content">
    <ng-content></ng-content>
  </div>
</div>


